// extracted by mini-css-extract-plugin
module.exports = {"slate-color-plugin--toolbar":"ColorButton_slate-color-plugin--toolbar__2P1j_"};